<template>
  <div>
    <div
      class="parent"
      :style="style"
      :class="[!showDetails ? 'parent-2' : '']"
    >
      <v-card @click="onClickSchool">
        <v-card-title class="info-title">
          <div class="text-center">
            {{ school.Name }}
          </div>
        </v-card-title>
      </v-card>
    </div>
  </div>
</template>

<script>
export default {
  props: ["school", "index", "showDetails"],
  methods: {
    /**
     * user click on cycle
     */
    onClickSchool() {
      if (!this.showDetails) {
        this.$emit("clicked", this.index);
      }
    },
    computed: {
      style() {
        var res = "";
        if (this.showDetails) {
          res += "position: fixed;";
          if (this.$store.getters.isMobile) {
            res += "width: 100%";
          } else {
            res += "width: calc(100% - 300px)";
          }
        }
        return res;
      },
    },
  },
};
</script>
<style scoped>
.v-card__title {
  border-radius: 15px !important;
}
</style>


